import { RMS_DETAILS_ERROR_DATA, RMS_DETAILS_HIDE_ERROR_DATA, RMS_HOLDING_DATA, RMS_HOLDING_START_LOADER, RMS_HOLDING_STOP_LOADER, RMS_SUBLIMITS_DATA, RMS_SUBLIMITS_START_LOADER, RMS_SUBLIMITS_STOP_LOADER, } from "../interface/iRmsDetails";
const initialState = {
    rmsSublimits: {},
    rmsHolding: {},
    rmsSublimitsLoader: false,
    rmsHoldingLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    rmsHoldingErrorData: {
        error: null,
        isOpen: false,
    },
};
const rmsDetails = (state = initialState, action) => {
    switch (action.type) {
        case RMS_SUBLIMITS_DATA:
            return Object.assign(Object.assign({}, state), { rmsSublimits: action.payload.rmsSublimits });
        case RMS_SUBLIMITS_START_LOADER:
            return Object.assign(Object.assign({}, state), { rmsSublimitsLoader: true });
        case RMS_SUBLIMITS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { rmsSublimitsLoader: false });
        case RMS_HOLDING_START_LOADER:
            return Object.assign(Object.assign({}, state), { rmsHoldingLoader: true });
        case RMS_HOLDING_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { rmsHoldingLoader: false });
        case RMS_DETAILS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case RMS_DETAILS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initialState[action.errorType] });
        case RMS_HOLDING_DATA:
            return Object.assign(Object.assign({}, state), { rmsHolding: action.payload.rmsHolding });
        default:
            return Object.assign({}, state);
    }
};
export default rmsDetails;
